<div class="row p-5">
    <div class="col p-5 ">
        <img [src]="logoUrl" alt="Logo" class="mb-4" style="height: 41px;">

        <h2 class="mb-3">Authentication Error</h2>

        <p class="text-primary">
            It appears you have encountered an authentication error. Please contact your administrator for assistance.
        </p>
        <div class="my-3">
            <a class="text-decoration-none" href="javascript:void(0);"  (click)="toggleDetails()">
                <span *ngIf="!showDetails"><i class="fa-solid fa-eye"></i> show details</span>
                <span *ngIf="showDetails"><i class="fa-solid fa-eye-slash"></i> hide details</span>
            </a>
        </div>

        <p *ngIf="showDetails">
            <b>Error Details</b>: <br> <span [innerHTML]="ErrorDescription"> </span>
        </p>

        <p class="mt-3">
            <button class="btn btn-primary" (click)="Logout()"><i class="fa-sharp fa-solid fa-arrow-left"></i> Login
                Again</button>
        </p>
    </div>
    <div class="col text-center p-5">
        <img [src]="imageUrl" alt="Error Image" class="img-fluid">
    </div>
</div>